var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg92(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-icon_weather_92",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.698 1.6c-.442 0-.8-.359-.8-.8 0-.442.358-.8.8-.8h15.594c.442 0 .8.358.8.8 0 .441-.358.8-.8.8H5.698zm0 19.392c-.442 0-.8-.358-.8-.8 0-.441.358-.8.8-.8h15.594c.442 0 .8.359.8.8 0 .442-.358.8-.8.8H5.698zm0-9.696c-.442 0-.8-.358-.8-.8 0-.442.358-.8.8-.8h15.594c.442 0 .8.358.8.8 0 .442-.358.8-.8.8H5.698zm7.597 4.898c-.442 0-.8-.358-.8-.8 0-.442.358-.8.8-.8H26.29c.442 0 .8.358.8.8 0 .442-.358.8-.8.8H13.295zm-12.495 0c-.442 0-.8-.358-.8-.8 0-.442.358-.8.8-.8h7.997c.441 0 .8.358.8.8 0 .442-.359.8-.8.8H.8zm0-9.696c-.442 0-.8-.359-.8-.8 0-.442.358-.8.8-.8h12.995c.441 0 .8.358.8.8 0 .441-.359.8-.8.8H.8zm17.493 0c-.442 0-.8-.359-.8-.8 0-.442.358-.8.8-.8h7.997c.442 0 .8.358.8.8 0 .441-.358.8-.8.8h-7.997z",
    transform: "translate(-475 -6) translate(25 6) translate(456 11)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg92);
export default __webpack_public_path__ + "static/media/92.3a879bd3361fd1d8ec2f1c476d5dc690.svg";
export { ForwardRef as ReactComponent };